$( function() {
  var winW = window.innerWidth

  if (winW > 768) {
    headerPcHandler()
  } else {
    headerMobileHandler()
    policyMobileHandler()
  }
  var mode = winW > 767 ? 'pc' : 'mobile'
  $( window ).resize(function() {
    $('.ellipsis').ellipsis()
    winW = window.innerWidth
    var newMode = winW > 767 ? 'pc' : 'mobile'
    if (mode !== newMode) {
      if (newMode === 'pc') {
        headerPcHandler()
      } else {
        headerMobileHandler()
        policyMobileHandler()
      }
      mode = newMode
    }
  })

  // select dropdown
  $.each($('.dropdown'), function(index, ele) {
    var className = $(ele).parents('.modal').length ? 'in-modal' : ''
    $(ele).selectmenu({
      position: { my: 'top', at: 'top' },
      classes: {
        'ui-selectmenu-menu': className
      },
      change: function (e, data) {
        if (data.item.index) {
          $(this).addClass('selected')
        } else {
          $(this).removeClass('selected')
        }
      }
  })
  })
    

  // datepicker
  $.datepicker.setDefaults({
    changeMonth: true,
    changeYear: true,
    monthNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    monthNamesShort: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    dayNames: ['일', '월', '화', '수', '목', '금', '토'],
    dayNamesShorts: ['일', '월', '화', '수', '목', '금', '토'],
    dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
    showMonthAfterYear: true
  })
  $('.datepicker').each( function () {
    $(this).datepicker({
      dateFormat: $(this).data('format') ? $(this).data('format') : 'yy-mm-dd',
      yearRange: $(this).data('range') ? $(this).data('range') : 'c-10:c+10',
      showOn: 'button',
      buttonImage: '/assets/images/icon-all-s-24-calendar-regular-lightgray.png',
      buttonImageOnly: true,
      showAnim: '',
      closeText: '확인',
      showButtonPanel: true,
      beforeShow: function (input, inst) {
        $(this).prop('disabled', true)
        if ($(this).data('format') === 'yy-mm') {
          $(inst.dpDiv).addClass('just-month')
          var format = $(this).val().split('-')
          var year = format[0] ? format[0] : inst.selectedYear
          var month = format[1] ? Number(format[1])-1 : inst.selectedMonth
          if (year && month) {
            $(this).datepicker('option', 'defaultDate', new Date(year, month, 1))
          }
        }
      },
      onClose: function(dateText, inst) { 
        if ($(this).data('format') === 'yy-mm') {
          $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1))
          $(inst.dpDiv).removeClass('just-month')
        }
        $(this).prop('disabled', false)
      }
    })
  })

  // accordion
  $('.acBtn').click(function () {
    $(this).siblings('.acContent').slideToggle(300).parent('.acBox').toggleClass('open').siblings().removeClass('open').find('.acContent').slideUp().siblings()
  })

  // tooltip
  $('button.btnTooltip').click(function() {
    $(this).find('.tooltip').toggle()
  })

  // header hover
  $('#btnTopMenuAll').click(function () {
    $(this).toggleClass('on')
    if ($(this).hasClass('on')) {
      $('#header').addClass('open');
    } else {
      $('#header').removeClass('open')
    }
    $('#maxMenuDropdown').toggle().toggleClass('open')
    $('#minMenuDropdown').hide()
    // $('#header').removeClass('open dropdown')
  })

  // emotion start
  $('#header').on('mouseleave', function() {
    if($('body').find('#btnTopMenuAll').hasClass('on')) {
      $('body').find('#btnTopMenuAll').click();
    }
  })
  // emotion end

  

  var listener = function (e) {
    e.preventDefault()
  }
  function headerPcHandler() {
    $('#clonedMaxMenuDropdown').remove()
    $('#mobileSideMenu').css({display: 'flex'})
    $('#topMenu a').each(function (idx, item) {
      item.removeEventListener('click', listener)
     })
    $('#topMenu a').mouseenter(function () {
      if ($('#maxMenuDropdown').hasClass('open')) {
        return false
      }
      $('#header').addClass('open')
      var target = $(this).data('target')
      if (target) {
        $(target).css({display: 'flex'}).siblings().hide()
        $('#minMenuDropdown').show().slideDown(200).css({height: 'auto'})
      } else {
        $('#minMenuDropdown').hide().find('.menu').hide()
      }
    })
    $('#header').mouseleave(function () {
      if ($('#maxMenuDropdown').hasClass('open')) {
        return false
      }
      $('#minMenuDropdown').stop().slideUp(200, function () {
        $('#header').removeClass('open dropdown')
      })
    })
  }
  function headerMobileHandler () {
    $('#mobileSideMenu').hide()
    $('#btnTopMenuAll').removeClass('on')
    $('#maxMenuDropdown').removeClass('open').hide()
    var clonedMenu = $('#maxMenuDropdown').clone(true).attr('id', 'clonedMaxMenuDropdown').show()
    $('#topMenu').after(clonedMenu)
    $(clonedMenu).find('.depth1 a').click(function(e) {
      if(!$(this).attr('href')) {
        e.preventDefault()
        $(this).parent().toggleClass('on').siblings().slideToggle(200).parent().siblings().find('.on').removeClass('on').siblings().slideUp(200)
      }
    })
    $(clonedMenu).find('.depth2 h4').click(function() {
      $(this).toggleClass('on').siblings().slideToggle(200).parent().siblings().find('.on').removeClass('on').siblings().slideUp(200)
    })
    $('#topMenu a').each(function (idx, item) {
      item.addEventListener('click', listener)
     })
  }

  $('#btnAuth').click(function () {
    $(this).siblings().toggle()
  })

  $('.btnBlind').click(function () {
    var target = $(this).siblings('input').prop('type') === 'text' ? 'password' : 'text'
    $(this).toggleClass('off').siblings('input').prop('type', target)
  })

  $.fn.modalHandler = function (bool, target) {
    if (bool) {
      $(target).css({display: 'flex'})
    } else {
      $(target).hide()
    }
  }

  $.fn.searchHandler = function (bool) {
    winW = window.innerWidth
    $('#dropSearchWrap').toggle(bool)
    if (bool) {
      if (winW > 768 ) $('#dropSearchWrap').toggleClass('open').css({top: $(this).parents('.inputWrap').offset().top + 60, left: $(this).parents('.inputWrap').offset().left})
    }
  }
  // slide up / down
  $.fn.slideToggleHandler = function (target) {
    $(this).toggleClass('open')
    $(target).slideToggle()
  }
  // jump to target
  $(document).on('click', '.btnJump', function (e) {
    winW = window.innerWidth
    var distance = winW > 767 ? 125 : 200
    e.preventDefault()
    var target = $(this).attr('href')
    var to
    if ($(this).parents().hasClass('modalBody')) {
      to = winW > 767 ? $(target).offset().top-$(this).parents('.policyWrap').offset().top+100 : $(target).offset().top-$(this).parents('.policyWrap').offset().top
      $(this).parents('.modalBody').scrollTop(to)
    } else if ($(this).parents().hasClass('scrollWrap')) {
      var parent = $(this).parents('.scrollWrap')
      to = $(target).offset().top - parent.offset().top + parent.scrollTop()-20
      parent.scrollTop(to)
    } else {
      $(window).scrollTop($(target).offset().top-distance)
    }
    if (target.indexOf('clause') > -1) {
      $(this).parents('.summary').find('.btnJump').removeClass('on')
      $(this).addClass('on')
    }
  })

  // policy
  function policyMobileHandler () {
    $('.summaryWrap .btnDrop').click(function () {
      $(this).toggleClass('open').siblings('.summary').slideToggle()
    })
    if($('.policyWrap').find('.summary').length) {
      $('#modalPolicy1').css({display: 'flex'})
      $('#modalPolicy2').css({display: 'flex'})
      var no, list = {
        '1': [],
        '2': []
      }
      $('.policyWrap').each(function (idx, ele) {
        no = $(ele).attr('id').replace('policyWrap', '')
        var summary = $(ele).find('.summary').clone(true)
        var offsetTop
        $(ele).find('.summaryWrap').append(summary)
        $(ele).find('.clause').each(function (jdx, ele2) {
          if ($(ele).parents().hasClass('modalBody')) {
            offsetTop = $(ele2).offset().top-165-$(ele).parents('.modalBody').offset().top
          } else {
            offsetTop = $(ele2).offset().top-205
          }
          list[no].push({
            offset: offsetTop,
            text: $(ele2).text(),
            id: $(ele2).attr('id')
          })
        })
      })
      $('.policyWrap .summaryWrap a').click(function () {
        $(this).parents('.summary').slideUp()
      })
      var current, scrollTop, i
      $(window).scroll(function () {
        scrollTop = $(window).scrollTop()
        if (!$('.policy').find('.policyWrap').attr('id')) {
          return false
        }
        if (scrollTop > $('.clause').first().offset().top) {
          $('.summaryWrap').css({top: '98px'})
        } else {
          $('.summaryWrap').css({top: '10px'}).find('.summary').slideUp()
        }
        no = $('.policy').find('.policyWrap').attr('id').replace('policyWrap', '')
        for (i = 0; i < list[no].length; i++) {
          if(scrollTop > list[no][i].offset) {
            current = list[no][i]
          }
        }
        if ($('.summaryWrap .btnDrop span').text() !== current.text) {
          $('.summaryWrap .btnDrop span').text(current.text)
          $('.summaryWrap a.on').removeClass('on')
          $('.summaryWrap a[href="#'+current.id+'"]').addClass('on')
        }
      })
      $('.policyModal').scroll(function () {
        scrollTop = $(this).scrollTop()
        if (!$(this).find('.clause')) {
          return false
        }
        if ($(this).find('.clause').first().position().top < 0) {
          $(this).find('.summaryWrap').css({top: '98px'})
        } else {
          $(this).find('.summaryWrap').css({top: '10px'}).find('.summary').slideUp()
        }
        no = $(this).find('.policyWrap').attr('id').replace('policyWrap', '')
        for (i = 0; i < list[no].length; i++) {
          if(scrollTop > list[no][i].offset) {
            current = list[no][i]
          }
        }
        if (current && $('.summaryWrap .btnDrop span').text() !== current.text) {
          $('.summaryWrap .btnDrop span').text(current.text)
          $('.summaryWrap a.on').removeClass('on')
          $('.summaryWrap a[href="#'+current.id+'"]').addClass('on')
        }
      })
      $('#modalPolicy1').hide()
      $('#modalPolicy2').hide()
    }
  }

  $('.videoWrap').click(function () {
    var videoWrap = $(this)
    var video = $(videoWrap).find('video').get(0)
    // emotion start
    if(videoWrap.parents('.sliderWrap').length) {
      videoWrap.parents('.sliderWrap').find('video').each(function() {
        $(this).get(0).pause();
      })
    }
    // emotion end
    if ($(videoWrap).hasClass('play')) {
      $(videoWrap).removeClass('play').addClass('pause')
      $(videoWrap).find('video').prop('controls', true)
      video.play()
    } else {
      $(videoWrap).removeClass('pause').addClass('play')
      video.pause()
      $(videoWrap).find('video').prop('controls', false)
    }
  })
  $('.input input').on('input', function(e) {
    if (e.target.value) {
      $(this).siblings('.btnErase').css({ opacity: 1 })
    } else {
      $(this).siblings('.btnErase').css({ opacity: 0 })
    }
  })
  $('.input .btnErase').click(function () {
    $(this).css({ opacity: 0 })
    $(this).siblings('input').val('')
  })

  $.fn.hashHandler = function () {
    var hash = window.location.hash
    var headerH = $('.topArea').height()+30
    if ($(hash).length) {
      var target = $(hash).offset().top - headerH
      $('html, body').animate({ scrollTop: target}, 300 )
    }
  }
  $('.ellipsis').ellipsis()
})